import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import GenericHeader from "../../components/GenericHeader/GenericHeader";
import { Globals as OldGlobals } from "../../global/Globals";
import Popup from "../../components/PopUp/PopUp";
import "./CreateNewBrief.css";
import BriefForm from "./BriefForm";
import Button from "../../components/Button/Button";
import { updateBriefAPI, getBriefByID } from "../../services/createBriefAPI";
import Loader from "../../components/Loader/Loader";
import Toast from "../../components/Toast/Toast";
import { formatISO } from "date-fns";
import CryptoUtils from "../../util/cryptoUtils";
import { useDispatch, useSelector } from "react-redux";
import { setIsBriefDetailsInValid, setIsSaveAsDraftClicked, setIsEvalDetailsValid, setIsProducerDetailsValid } from "./CreateBriefSlice";
import { useLanguage } from '../../context/Languagecontext';
const CreateNewBrief = (props) => {
  const { Globals } = useLanguage();
  const params = useParams();
  const defaultFormData = {
    PROPOSAL_ID: params?.id,
    CHANNEL: 0,
    LANGUAGE: 0,
    GENRE: 0,
    FORMAT: 0,
    PRODUCTION_TYPE: 0,
    DESCRIPTION: "string",
    SUBMISSION_REQUIREMENT: "string",
    CLOSING_DATE: "2025-03-01T17:38:20.209Z",
    COMMISSIONING_EDITORS: ["3fa85f64-5717-4562-b3fc-2c963f66afa6"],
    CE_EVALUATION_DEADLINE: null,
    SENIOR_MANAGER_EVALUATION_DEADLINE: null,
    EVALUATION_PROCESS: "string",
    CRITERIA: [],
    EXTRA_CRITERIA: [
      {
        customCriteriaId: 0,
        customCriteriaName: "",
      },
    ], // optional
    BRIEF_TYPE: 0,
    PRODUCERS: [""],
  };
  const optionalFields = ["EXTRA_CRITERIA", "CRITERIA", "EVALUATION_PROCESS"];
  const [popupState, setPopupState] = useState(null);
  const [loading, setLoading] = useState(false);
  const [briefData, setBriefData] = useState(null);
  const [toast, setToast] = useState(null);
  const [isValidated, setValidated] = useState(false);
  const [formData, setFormData] = useState(defaultFormData);
  const [clusterInfo, setClusterInfo] = useState(null);
  const doesBriefHaveValue = useSelector(state => state.createBrief.isBriefDetailsPartiallyFilled);
  const doesEvalHaveValue = useSelector(state => state.createBrief.isEvaluationPartiallyFilled);
  const doesProducerSectionHaveValue = useSelector(state => state.createBrief.isProducerPartiallyFilled);
  const dispatch = useDispatch();
  useEffect(() => {
    const newCluster = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"));
    if (newCluster && newCluster.length > 0 && newCluster?.[0]) {
      setClusterInfo(newCluster?.[0]);
    }
  }, []);

  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    resetSates();
    if (popupState === "brief" || popupState === "draft") {
        createBriefSeviceCall(popupState === "draft" ? 6 : 0);
    } else {
      navigate(-1);
    }
  }, [navigate, popupState]);

  const resetSates = () => {
    setPopupState("");
  };

  const postDateFormat = (date) => {
    return formatISO(date).split("+")[0];
  };

  const postData = (type, postData) => {
    const data = {
      bRefNo: briefData.bRefNo,
      proposalId: postData.PROPOSAL_ID,
      proposalType: postData.BRIEF_TYPE,
      description: postData.DESCRIPTION,
      submissionRequirements: postData.SUBMISSION_REQUIREMENT,
      evalAndSelection: postData.EVALUATION_PROCESS,
      formatId: postData.FORMAT?.[0],
      languageId: postData.LANGUAGE?.[0],
      genreId: postData.GENRE?.[0],
      channelId: postData.CHANNEL?.[0],
      clusterId: clusterInfo?.clusterId || 1,
      productionTypeId: postData.PRODUCTION_TYPE?.[0],
      //closingDate: formData.CLOSING_DATE && postDateFormat(postData.CLOSING_DATE),//:"2025-11-30T00:00:00",
      briefStatus: type,
      //ceEvalDeadline: formData.CE_EVALUATION_DEADLINE && postDateFormat(postData.CE_EVALUATION_DEADLINE),
      /*smEvalDeadline: formData.SENIOR_MANAGER_EVALUATION_DEADLINE && postDateFormat(
        postData.SENIOR_MANAGER_EVALUATION_DEADLINE
      ),*/
      createdBy: "2f55b3fb-0607-40b0-831b-7f621a818541",
      updatedBy: "2f55b3fb-0607-40b0-831b-7f621a818541",
      criteriaIds: postData?.CRITERIA,
      customCriteriaList:
        postData?.EXTRA_CRITERIA?.filter((e) =>
          e.customCriteriaName?.trim()
        )?.map((e) => ({
          customCriteriaId: e?.customCriteriaId || 0,
          customCriteriaName: e?.customCriteriaName,
        })) || [],
      producers: postData?.PRODUCERS?.map((e) => e.id)?.filter((e) => e) || [],
      commisioningEditors:
        postData?.COMMISSIONING_EDITORS?.map((e) => e.id).filter((e) => e) ||
        [],
    };
    if (formData.CLOSING_DATE) {
      data["closingDate"] = formData.CLOSING_DATE && postDateFormat(postData.CLOSING_DATE);//:"2025-11-30T00:00:00",
    }
    if (formData.CE_EVALUATION_DEADLINE) {
      data["ceEvalDeadline"] = formData.CE_EVALUATION_DEADLINE && postDateFormat(postData.CE_EVALUATION_DEADLINE);
    }
    if (formData.CE_EVALUATION_DEADLINE) {
      data["smEvalDeadline"] = formData.SENIOR_MANAGER_EVALUATION_DEADLINE && postDateFormat(
        postData.SENIOR_MANAGER_EVALUATION_DEADLINE
      );
    }
    return data;
  };
  const createBriefSeviceCall = async (type) => {
    try {
      const response = await updateBriefAPI(postData(type, formData));
      if (response.data.status === "OK") {
              navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "internal_dashboard", toastValue: (type === 0 ?Globals.CREATE_NEW_BRIEF.TOAST_EDIT_SUCCESS:Globals.CREATE_NEW_BRIEF.TOAST_SAVE_AS_DRAFT_SUCCESS) } });
      
      }
    } catch (error) {
      setToast({ isOpen: true, status: "error", title: "Action Error" });
      console.error("Error edit brif", error);
    }
  };
  const handleButtonClick = useCallback(
    (type) => {
      if (type === "brief") {
        if (isValidated) {
          setPopupState(type);
        } else {
          setPopupState("");
        }
      } else {
        if (type === "draft") {
          //combineAllFormData();
          dispatch(setIsSaveAsDraftClicked({ isSaveAsDraftClicked: true }));
        }
        setPopupState(type);
      }
    },
    [formData]
  );

  const handleToastClose = () => {
    setToast(false);
  };

  const validate = (newData) => {
    let isFormDataValid = Object.entries(newData)
      .filter(
        ([key]) =>
          ![
            ...optionalFields,
            newData.BRIEF_TYPE === 0 ? "PRODUCERS" : "",
          ].includes(key)
      ) // Filter out optional fields
      .every(([_, value]) => {
        if (Array.isArray(value)) {
          return value.length !== 0;
        }
        return value !== "" && value !== null;
      });

    if (isFormDataValid) {
      if (
        newData.CRITERIA.length === 0 &&
        newData.EXTRA_CRITERIA?.filter((e) => e.customCriteriaName?.trim())
          .length === 0
      ) {
        isFormDataValid = false;
      }
    }
    return isFormDataValid;
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      if (params.id) {
        try {
          const result = await getBriefByID(params.id);
          setLoading(false);
          if (result.data.status === "OK" && result.data.content) {
            setBriefData(result.data.content);
          } else {
            console.error("Error in fetching brief info", result.data.status);
            navigate(-1);
          }
        } catch (error) {
          setLoading(false);
          console.error("Error in fetching brief info", error);
          navigate(-1);
        }
      }
    };
    fetchData();
  }, [params.id]);

  const combineAllFormData = useCallback((data) => {
    setFormData((prevData) => {
      const newData = { ...prevData, ...data };
      let isFormDataValid = validate(newData);
      setValidated(isFormDataValid);
      return newData;
    });
  }, []);

  const resetStates = useCallback(() => {
    setPopupState(null);
  }, []);

  const showPopup = useCallback(
    (title, message, button1) => (
      <Popup
        title={title}
        text={message}
        normalAction={popupState !== "cross" ? handleBack : null}
        normalActionText={popupState !== "cross" ? button1 : ""}
        negativeAction={popupState === "cross" ? handleBack : null}
        negativeActionText={popupState === "cross" ? button1 : ""}
        popupType="abort"
        onClose={resetStates}
        buttonBGColor={popupState !== "cross" ? "#004894" : ""}
      />
    ),
    [handleBack, resetStates, popupState]
  );

  return (
    <div className="create-newbrief-main-container">
      {loading && <Loader height={50} width={50} component={"Myproposals"} />}
      <div className="brief-form-header">
        <GenericHeader
          title={Globals.CREATE_NEW_BRIEF.HEADER_TITLE}
          onClose={() => handleButtonClick("cross")}
        />
      </div>
      {briefData && (
        <BriefForm
          propsData={briefData}
          formData={formData}
          handleDropdown={() => {}}
          handleTextAreaSelection={() => {}}
          handleInfo={() => {}}
          handleDatePicker={() => {}}
          handleCheckboxData={() => {}}
          handleBriefDetailsData={combineAllFormData}
          hanleEvaluationData={combineAllFormData}
          handleProducerData={combineAllFormData}
        />
      )}
      <div className="brief-button-group-container brief-fixed-footer">
        <div className="brief-button-group">
          <button
            className="brief-cancel-btn"
            onClick={() => handleButtonClick("cross")}
          >
            {Globals.CREATE_NEW_BRIEF.CANCEL_BUTTON}
          </button>
          <Button
            title={Globals.CREATE_NEW_BRIEF.SAVE_AS_DRAFT}
            additionalStyle={`brief-draft-btn ${
              (doesBriefHaveValue === true || doesEvalHaveValue === true || doesProducerSectionHaveValue === true) ? "" : "brief-draft-btn-disabled"
            }`}
            action={(doesBriefHaveValue === true || doesEvalHaveValue === true || doesProducerSectionHaveValue === true) ? () => handleButtonClick("draft") : null}
            disabled={doesBriefHaveValue === true || doesEvalHaveValue === true || doesProducerSectionHaveValue === true}
          />
          <Button
            title={Globals.CREATE_NEW_BRIEF.CREATE_BRIEF}
            additionalStyle={
              isValidated ? "brief-create-btn-active" : "brief-create-btn-disabled"
            }
            id="Create-Brief-Button"
            action={() => handleButtonClick("brief")}
            disabled={!isValidated}
          />
        </div>
      </div>
      {popupState &&
        showPopup(
          Globals.EDIT_NEW_BRIEF.POPUP[popupState].TITLE,
          Globals.EDIT_NEW_BRIEF.POPUP[popupState].MESSAGE,
          Globals.EDIT_NEW_BRIEF.POPUP[popupState].BUTTON_TEXT
        )}
      {toast?.isOpen && (
        <div className="toast-container">
        <Toast
          status={toast?.status}
          onClose={handleToastClose}
          title={toast?.title}
          extraClass={"toast-container-extra-style"}
        />
        </div>
      )}
    </div>
  );
};

export default CreateNewBrief;
